module.exports = __webpack_public_path__ + "img/mag-cnn.1d88c4f1.png";